import React from "react"
import Layout from "../components/layout"

export default function Impressum() {
  return (
    <Layout>
      <h1>Impressum</h1>
    </Layout>
  )
}
